import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CustomCollapseCard, Text, CustomRadioGroup, CustomRadio } from '@src/components';

import {
  setTotalAutoLoading,
  updateAutoLoadingCommand,
} from '@src/store/slice/autoUploadInstructionsSlice';

import '@src/styles/balanceUpload/orderType.scss';

const UploadPriceType = () => {
  const dispatch = useDispatch();

  const { totalAutoLoading, autoLoadingId, integrationId } = useSelector(
    (state) => state?.autoUploadInstructions,
  );

  const formChange = useCallback(
    async (e) => {
      if (autoLoadingId && autoLoadingId > 0) {
        await dispatch(
          updateAutoLoadingCommand({
            id: totalAutoLoading?.id,
            periodType: Number(e.target.value),
            confirmEveryMonth: totalAutoLoading?.confirmEveryMonth,
            startDay: totalAutoLoading?.startDay,
            isActive: true,
            orderProcessType: totalAutoLoading?.orderProcessType,
            monthChoice: totalAutoLoading?.chooseMonth,
          }),
        );
      }

      if (integrationId && integrationId > 0) {
        await dispatch(
          updateAutoLoadingCommand({
            integrationId: integrationId,
            periodType: Number(e.target.value),
            confirmEveryMonth: totalAutoLoading?.confirmEveryMonth,
            startDay: totalAutoLoading?.startDay,
            isActive: totalAutoLoading?.isActive,
            orderProcessType: totalAutoLoading?.orderProcessType,
            monthChoice: totalAutoLoading?.chooseMonth,
          }),
        );
      }

      dispatch(
        setTotalAutoLoading({
          ...totalAutoLoading,
          periodType: Number(e.target.value),
        }),
      );
    },
    [dispatch, totalAutoLoading, autoLoadingId, integrationId],
  );

  return (
    <CustomCollapseCard
      className="order-type-card order-input-form-page"
      bodyCenter
      cardTitle={<Text t="orderPriceTypeTitle" />}
      cardTitleAlign="center"
    >
      <CustomRadioGroup
        id="ticketRestaurant-autoUploadInstructions-instructionInformations-instructionType-additionalInformation-radioGroup"
        value={totalAutoLoading?.periodType}
        onChange={formChange}
      >
        <CustomRadio
          id="ticketRestaurant-autoUploadInstructions-instructionInformations-instructionType-additionalInformation-monthlyAmount-radio"
          value={1}
          title={<Text t="monthlyAmount" />}
          description={<Text t="youMustSpecifyHowManyTlOfBalance" />}
        />
        <CustomRadio
          id="ticketRestaurant-autoUploadInstructions-instructionInformations-instructionType-additionalInformation-dailyAmount-radio"
          value={0}
          title={<Text t="dailyAmount" />}
          description={<Text t="youMustSpecifyHowManyTlOfBalance2" />}
        />
      </CustomRadioGroup>
    </CustomCollapseCard>
  );
};

export default UploadPriceType;
